resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';// Dialog
/*
Sample declaration:
<div data-mogo-ui="Dialog" id="dialogId">Content goes here</div>
*/
function Dialog () {
  this.extends = [_AccessibleContainer, _ResponsiveLayout];
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this._initialized = false;
  this._pending = null;
  this._arrowShown = true;
  this._arrowCurrentState = false;
  this._contentDiv = null;
  this._urlLoaded = null;

  this._body = $('body');
  this._header = null;
  this.overlay = null;
  this.close = true;
  this.backgroundClose = true;
  this.width = null;
  this.height = null;
  this.onClickClose = null;
  this.url = null;
  this.fullScreen = false; // Transparent: dark boarders instead of the white one.
  this.cinematic = false; // Full width with no padding (cinematic class), IE for YouTube player
  this.animation = true;
  this.trigger = null; // optional element that will trigger showing the dialog
  this.onUrlLoaded = null; // callback for loading the content of the dialog
  this.disableBackgroundScroll = false;
  this.fixFormsOnTouchDevices = false;

  this.init = function () {
    // Analytics definition
    this.analytics = new Analytics();
    this.analytics.extendEventObject({
      'component-dialog-action': {
        event: 'DLevent.modalDialog',
        modalDialogID: function () {
          return this.id;
        },
        modalDialogAction: function (action) {
          return action;
        }
      }
    });

    // Create overlay and move Dialog div, create container div
    this.overlay = $("<div class='mogo-ui-dialog-overlay' id='" + this.id + "_overlay'>")[0];
    $('body').append(this.overlay);
    $(this.node).appendTo(this.overlay);
    var containerDiv = $("<div class='dialog_container js--tab-trapper'></div>");
    this._contentDiv = $("<div class='dialog_container_content'></div>")[0];

    if (this.header) {
      // is a header specified in the dialog
      this._header = $('<h1>');
      this._header.text(this.header);
      this._header.prependTo(containerDiv);
    }
    $(this.node)
      .contents()
      .appendTo(this._contentDiv);
    $(this._contentDiv).appendTo(containerDiv);
    $(containerDiv).appendTo(this.node);
    this.arrow = $(
      '<div class="icon-arrowdown dialog"><svg class="svg-icon" viewBox="0 0 32 32"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrowdown"></use></svg></div>'
    );
    $(this.arrow).prependTo(containerDiv);

    // Apply styles
    $(this.node).css('display', 'none');
    $(this.node).addClass('mogo-ui-dialog');
    // all animations are default to true unless specified.
    // no animation will no show the transforming flip
    if (this.animation === false) {
      $(this.node).addClass('mogo-ui-dialog--noanimation');
    }
    if (this.fullScreen) $(this.node).addClass('transparent');
    if (this.cinematic) {
      // Add cinematic class to overlay as well because the close button is different
      $(this.node).addClass('cinematic');
      $(this.overlay).addClass('mogo-ui-dialog-overlay--cinematic');
    }
    if (this.width != null) $(this.node).css('width', this.width);
    if (this.height != null) $('.dialog_container_content', this.node).css('height', this.height);

    // Load data
    if (this.url != null) this._loadData(this.url);

    // Close icon, background close
    /*
    * Chrome does not support fixed positioning
    * for child elements if the parent has 3d transformation
    * Hence, we change the icon's location on full-screen
    */

    if (this.close) {
      var closeIconContainer =
        '<a href="javascript:void(0);" class="icon--close dialog"><svg class="svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-close2"></use></svg></a>';

      var overlay = '#' + this.id + '_overlay';
      if (this.fullScreen) {
        $(this.overlay).prepend(closeIconContainer);
        $('.icon--close', this.overlay).on('click', $.proxy(this.hide, this));
      } else {
        $(containerDiv).prepend(closeIconContainer);
        $('.icon--close', this.node).on('click', $.proxy(this.hide, this));
      }
    }
    if (this.backgroundClose) {
      $(this.overlay).on('click', $.proxy(this._onBackgroundClose, this));
    }

    // Resize bind handler
    if (!navigator.userAgent.match(/android/i)) {
      this.registerResponsiveFunction($.proxy(this.resize, this), null, null);
    } else this.registerResponsiveFunction($.proxy(this.delayResize, this), null, null);

    $(window).on('orientationchange', $.proxy(this.delayResize, this, 500));
    $('.dialog_container_content', this.node).on('scroll', $.proxy(this.scroll, this));
    this._previouslyFocusedElement();
  };

  this.initAllReady = function () {
    if (this.url != null && this._urlLoaded == null) return;

    this.resize();
    this._initialized = true;

    if (this._pending != null) {
      this[this._pending]();
      this._pending = null;
    }

    if (this.trigger != null) {
      $(document)
        .find('.' + this.trigger)
        .on('click', $.proxy(this._triggerPopup, this));
    }

    // closes dialog when user press ESC key
    var _hide = this.hide.bind(this);
    $(document).keyup(function (e) {
      if (e.which === 27) {
        _hide();
      }
    });

    this._super();
  };

  this._triggerPopup = function (e) {
    e.preventDefault();
    this.show();
  };

  this.delayResize = function (time) {
    if (time == null) time = 1000;
    setTimeout($.proxy(this.resize, this), time);
  };

  this.scroll = function () {
    if (this._arrowCurrentState == true && this._arrowShown == false) {
      var scrollPos = $('.dialog_container_content', this.node).scrollTop();
      var heightDiff = this._contentHeight - $(this.node).height();
      if (scrollPos > 100 || scrollPos >= heightDiff - 5) {
        $(this.node).removeClass('arrow');
        this._arrowCurrentState = false;
        this._arrowShown = true;
      }
    }
  };

  this.resize = function () {
    // Size check
    if ($(this.node).css('display') == 'none') $(this.node).addClass('sizeCheck');

    $('.dialog_container_content', this.node).css('height', 'auto');
    if (this.height != null) $('.dialog_container_content', this.node).css('height', this.height);
    var headerHeight = this._header
      ? this._header.outerHeight() + parseInt(this._header.css('margin-bottom'))
      : 0;
    var innerHeight = $(this.node).height() - headerHeight;
    this._contentHeight = $('.dialog_container_content', this.node).outerHeight();
    if (this._contentHeight > innerHeight + 3) {
      // 3px for chrome issues
      this._arrowCurrentState = true;
      this._arrowShown = false;
      $(this.node).addClass('arrow');
      $('.dialog_container_content', this.node).css('height', innerHeight + 'px');
    } else {
      this._arrowShown = true;
      this._arrowCurrentState = false;
      $(this.node).removeClass('arrow');
    }
    var height = $(this.node).outerHeight();
    var width = $(this.node).outerWidth();
    var windowHeight = $(window).outerHeight();
    var windowWidth = $(window).outerWidth();
    this._top = windowHeight / 2 - height / 2;
    this._left = windowWidth / 2 - width / 2;
    $(this.node).css('left', this._left + 'px');
    $(this.node).css('top', this._top + 'px');
    $(this.node).removeClass('sizeCheck');
  };

  this.show = function (newUrl) {
    $('body').addClass('js--accessible-container-displayed');
    this._accessibilityVisibility(true);

    if (newUrl != null) {
      this._loadData(newUrl, true);
      return false;
    }

    if (!this._initialized) {
      this._pending = 'show';
      return;
    }

    // Show overlay
    $(this.overlay).css('display', 'block');
    setTimeout(
      $.proxy(function () {
        $(this.overlay).addClass('shown');
      }, this),
      60
    );

    // Resize to get correct height/width
    this.resize();

    // Show dialog
    setTimeout(
      $.proxy(function () {
        $(this.node).css('display', 'block');
        setTimeout(
          $.proxy(function () {
            $(this.node).addClass('shown');
            // Disable background scrolling
            if (this.disableBackgroundScroll) {
              this._body
                .addClass('disableScroll')
                .on('touchmove.dialog', $.proxy(this._onScrollTouchMove, this));
            }
            if (this.fixFormsOnTouchDevices) {
              this._fixFormsOnTouchDevices();
            }
          }, this),
          200
        );

        // Resize for arrow
        setTimeout(
          $.proxy(function () {
            this.resize();
            $(this.node).attr('tabindex', -1);
            this._trapTab();
            $(this.node).focus();
          }, this),
          550
        );
      }, this),
      20
    );

    this.analytics.pushEvent('component-dialog-action', {modalDialogAction: ['Shown']}, this);

    return false;
  };

  this.hide = function (event) {
    $(this.node).removeAttr('tabindex');
    $('body').removeClass('js--accessible-container-displayed');
    this._accessibilityVisibility(false);
    if (event) event.preventDefault();
    // Hide Dialog
    $(this.node).removeClass('shown');

    // Hide overlay, reset properties to display: none
    setTimeout(
      $.proxy(function () {
        $(this.overlay).removeClass('shown');
      }, this),
      250
    );
    setTimeout(
      $.proxy(function () {
        $(this.node).css('display', 'none');
        $(this.overlay).css('display', 'none');
        // Re-Enable background scrolling
        if (this.disableBackgroundScroll) {
          this._body.removeClass('disableScroll').off('touchmove.dialog');
        }
      }, this),
      500
    );

    // Callback
    if (this.onClickClose != null && typeof this.onClickClose === 'function') {
      setTimeout(this.onClickClose, 350);
    }

    // Analytics
    if (event) {
      if ($(event.target).parents('.mogo-ui-dialog').length == 0 &&
          !$(event.target).hasClass('mogo-ui-dialog')) {
        this.analytics.pushEvent('component-dialog-action', {modalDialogAction: ['Closed by background']}, this);
      } else {
        this.analytics.pushEvent('component-dialog-action', {modalDialogAction: ['Closed by cta']}, this);
      }
    } else {
      this.analytics.pushEvent('component-dialog-action', {modalDialogAction: ['Closed by application']}, this);
    }
  };

  this._onBackgroundClose = function (e) {
    if (
      $(e.target).parents('.mogo-ui-dialog').length == 0 &&
      !$(e.target).hasClass('mogo-ui-dialog')
    ) {
      this.hide(e);
    }
  };

  this._loadData = function (url, showAfter) {
    if (this._urlLoaded != null && this._urlLoaded == url && showAfter == true) {
      this.show();
    }

    if (url != null && (this._urlLoaded == null || this._urlLoaded != url)) {
      this.url = url;
      this._urlLoaded = null;
      var params = {
        url: url,
        contentType: 'text/html',
        dataType: 'html',
        success: $.proxy(this._loadDataSuccess, this, showAfter),
        error: $.proxy(this._loadDataError, this)
      };
      $.ajax(params);
    }
  };

  this._loadDataSuccess = function (showAfter, data) {
    $(this._contentDiv).html(data);
    this._urlLoaded = this.url;
    if (!this._initialized) this.initAllReady();

    // callback with the content has been loaded on the page
    if (this.onUrlLoaded) this.onUrlLoaded();

    if (showAfter != null && showAfter == true) this.show();
  };

  this._loadDataError = function (error) {
    console.error(error);
  };

  this._fixFormsOnTouchDevices = function () {
    // change position from fixed to absolute while fields are focused to avoid a jerky mobile experience
    if ('ontouchstart' in window) {
      var $body = $('body');
      $(this.node)
        .on('focus.dialog', 'input', function () {
          $body.addClass('fixfixed');
        })
        .on('blur.dialog', 'input', function () {
          $body.removeClass('fixfixed');
        });
    }
  };

  this._onScrollTouchMove = function (event) {
    // don't scroll elements with disableScroll on them
    var isTouchMoveAllowed = true,
      target = event.target;
    while (target !== null) {
      if (target.classList && target.classList.contains('disableScroll')) {
        isTouchMoveAllowed = false;
        break;
      } else if (target.classList && target.classList.contains('dialog_container_content')) {
        isTouchMoveAllowed = true;
        break;
      }
      target = target.parentNode;
    }
    if (!isTouchMoveAllowed) {
      event.preventDefault();
    }
  };

  this.destroy = function () {
    if (this.trigger != null) {
      $(document)
        .find('.' + this.trigger)
        .off('click');
    }
    $(this.node).unwrap();
  };
}
